<template>
  <section>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
        <ul>
          <li class="formList">

            <dl>
              <dd>
                <date-range-component v-on:event="getSearchDate" label="가입일"
                                      :value="searchDate"></date-range-component>
              </dd>
              <dd>
                <div class="monthBx" style="width:220px">
                  <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                          :class="{ active: month === activeItem}"
                          @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                  </button>
                </div>
              </dd>
            </dl>

            <dl>
              <dd>
                <v-select v-model="param.searchRole" :items="userRoleItems" item-text="roleName"
                          item-value="roleId" label="역할"
                          dense
                          clearable
                          flat
                          outlined
                          v-on:change="search"
                />
              </dd>
            </dl>

            <dl>
              <dd>
                <v-col sm="6">
                  <v-text-field label="이메일/아이디/이름/휴대폰번호 검색"
                                v-model="searchValue" v-on:keyup.enter="search"
                                dense clearable flat outlined style="max-width: 90%"/>
                </v-col>
              </dd>
            </dl>

          </li>
        </ul>
      </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <div class="tableBtn">
          <v-col>
          <ul>
            <li class="tableBtnList">
              <v-btn color="#58d8a3" depressed dark @click="setPosition('chairman')">위원장 설정</v-btn>
            </li>
            <li class="tableBtnList">
              <v-btn color="#ffc105" depressed dark @click="setPosition('secretary')">간사 설정</v-btn>
            </li>
            <li class="tableBtnList">
              <v-btn color="grey" depressed dark @click="setPosition()">평회원 설정</v-btn>
            </li>
          </ul>
          </v-col>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="users"
            :server-items-length="totalItems"
            :options.sync="options"
            item-key="userId"
            show-select
            single-select
            class="elevation-1"
        >
          <template v-slot:item.name="{value, item}">
            <template v-for="(g, index) in item.userHasGroups">
              <span v-if="g.id.groupId === group.groupId && g.groupPosition === 'chairman'" :key="index">위원장 / </span>
              <span v-if="g.id.groupId === group.groupId && g.groupPosition === 'secretary'" :key="index">간사 / </span>
            </template>
            {{ value }}
          </template>
          <template v-slot:item.userId="{value}">
<!--            <a @click.stop="onRowClick(value)">-->
              {{ value }}
<!--            </a>-->
          </template>

          <template v-slot:item.departmentGroup="{value}">
            {{  groupName(value) }}
          </template>
          <template v-slot:item.clubGroup="{value}">
            {{  groupName(value) }}
          </template>

          <template v-slot:item.createdAt="{ value }">
            {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
          </template>

        </v-data-table>
      </div>
    </article>

  </section>
</template>

<script>
import DateRageComponent from "@/views/component/DateRageComponent"
import userApi from '@/api/UserApi'
import roleApi from "@/api/RoleApi"
// import _ from "lodash"


export default {
  name: "GroupUserList",
  components: {
    'date-range-component': DateRageComponent
  },
  props: {
    group: Object
  },
  data: () => ({
    date: new Date(),
    // fromDate: new Date().toISOString().substr(0, 10),
    // toDate: new Date().toISOString().substr(0, 10),
    menu: false,
    menu2: false,
    userRoleItems: [],
    userStateItems: [
      {text: '일반', value: 'STATE_NORMAL'},
      {text: '대기', value: 'STATE_REQUEST'},
      {text: '심사중', value: 'STATE_EXAMINATION'},
      {text: '반려', value: 'STATE_REJECT'},
      {text: '탈퇴', value: 'STATE_WITHDRAW'},
      {text: '탈퇴대기', value: 'STATE_WITHDRAW_REQUEST'},
      {text: '휴면', value: 'STATE_DORMANT'},
      {text: '차단', value: 'STATE_BLOCKED'}
    ],
    keywordType: ['아이디', '이름', '닉네임', '휴대폰'],
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    monthOn: false,
    activeItem: null,
    emailType: [{value: null, text: '전체'}, {value: true, text: 'Y'}, {value: false, text: 'N'}],
    smsType: [{value: null, text: '전체'}, {value: true, text: 'Y'}, {value: false, text: 'N'}],
    selected: [],
    headers: [
      {text: '아이디', value: 'userId', sortable: false},
      {text: '이름', value: 'name', sortable: false},
      {text: '이메일', value: 'email', sortable: false},
      {text: '휴대폰번호', value: 'mobileNo', sortable: false},
      {text: '분과', value: 'departmentGroup', sortable: false, align: 'left'},
      {text: '동호회', value: 'clubGroup', sortable: false, align: 'left'},
      {text: '가입일', value: 'createdAt', sortable: false},
    ],
    options:{},
    param: {
      searchState: null,
      searchRole: null,
      keyType: null,
      searchKeyword: null,
      username: null,
      name: null,
      local: null,
      fromJoin: null,
      toJoin: null,
      sms: null,
      page: 1
    },
    users: [],
    totalItems: 0,
    searchDate: [],
    dialogVisible: false,
    selectedUser: {},
    waitingSearch: false,
    searchValue: null,
    currentStateName:'일반회원'

  }),
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    },
    searchValue: {
      handler(nv) {
        this.options.page = 1;
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      }
    },
    group: function () {
      this.search();
    },
  },
  methods: {
    groupName(value) {
      if(!value)
        return '';
      // value.filter(v => v.joinState === 'STATE_APPROVAL').length > 1 ? value[0].groupName + ' 외 ' + (value.filter(v => v.joinState === 'STATE_APPROVAL').length-1) : value.filter(v => v.joinState === 'STATE_APPROVAL').length > 0 ? value.filter(v => v.joinState === 'STATE_APPROVAL')[0].groupName : ''
      const approvalList = (value??[]).filter(v => v.joinState === 'STATE_APPROVAL');
      const approvalSize = approvalList.length;
      const masterGroup = approvalList?.[0]?.groupName??'';

      return masterGroup + (approvalSize > 1 ? ' 외 ' + (approvalSize-1) : '')
    },
    setPosition(position){

      if(!this.group || !this.group.groupId) {
        alert("분류를 선택해주세요.")
        return;
      }
      if(!this.selected || this.selected.length !== 1) {
        alert('설정하실 회원을 선택해주세요.')
        return;
      }

      userApi.setPosition(position, this.selected[0].userId, this.group.groupId).then(() => {
        alert('설정되었습니다.');
        this.search();
      });

    },
    onRowClick(value) {
      this.$router.push({path:`/user/${value}`});
    },
    initSearch() {
      for (const [key] of Object.entries(this.param)) {
        this.param[key] = '';
      }
    },
    getSearchDate(searchDate = []) {
      this.searchDate = searchDate;
      this.search();
    },
    selectItem(months) {
      this.activeItem = months;
      this.searchDate = [];
      if (this.activeItem !== 0) {
        this.searchDate.push(this.$moment().subtract(months, "months").format('YYYY-MM-DD'));
        this.searchDate.push(this.$moment().format('YYYY-MM-DD'));
      }
      this.search();
    },
    search() {
      const {  page, itemsPerPage, size } = this.options;
      let params = {...this.param, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};

      if (this.activeItem > 0) {
        // params.fromJoin = this.fromDate;
        // params.toJoin = this.toDate;
        params.fromDate = this.searchDate[0];
        params.toDate = this.searchDate[1];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }
      // console.log(this.group);

      params.searchGroup = this.group?.groupId??null;

      if(params.searchGroup !== null)
        userApi.groupUsers(params).then(data => {
          this.users = data.content;
          this.totalItems = data.totalElements;

          console.log(this.users);

        });
    },
  },
  created: function () {
    this.param.searchState = this.$route.params.state;
    this.userStateItems.forEach(i => {
      if(this.param.searchState) {
        if (i.value === this.param.searchState) {
          this.currentStateName = i.text;
        }
      }
    });
    roleApi.list(true).then(data => {
      this.userRoleItems = data;
    });
    this.search();
    // userApi.list(this.param).then(data => {
    //   this.users = data.content;
    //   this.totalItems = data.totalElements;
    // });

  }
}
</script>


<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    //width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }

              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        margin-right: 15px;
      }
    }
  }
}
</style>